import React, { useEffect } from 'react';
import 'components/campaign/campaignCreation/CreateCampaignStepTwo.scss';
import { useDispatch, connect } from 'react-redux';
import { ContinueWithBackButtons } from 'components/base/BottomStepComponent';
import { useFormContext } from 'react-hook-form';
import { validate } from 'containers/engagement/campaign/CreateCampaignValidate';
import { scrollToFirstError } from 'components/campaign/campaignCreation/CreateCampaignHandleError';
import { CREATION_STEP_TWO_CONFIG } from './StampCampaignCreationConfig';
import BaseCreationStepContentByConfig from 'components/base/BaseCreationStepContentByConfig';

function CreateStampCampaignStepTwoV2() {
  const dispatch = useDispatch();
  const { getValues, setValue, setError, clearErrors, formState: { errors } } = useFormContext();
  const { extraValidate } = CREATION_STEP_TWO_CONFIG;

  useEffect(() => {
    const executionPriority = getValues("executionPriority");
    if (!executionPriority) {
      setValue("executionPriority", 1, { shouldDirty: true });
    };
  }, []);

  useEffect(() => {
    scrollToFirstError(
      errors,
      [
        "executionPriority",
        "customerGroup",
        "segments",
        "activeEndDate",
        "visibleEndDate",
      ]
    )
  }, [errors])

  const stepChangeAction = (isBack) => {
    let isValid = validate({
      getValues: getValues,
      setError,
      clearErrors,
      step: 1,
      isBack,
    });
    if (extraValidate) {
      isValid = extraValidate({
        getValues,
        setError,
        clearErrors
      }) && isValid
    }
    dispatch({
      type: 'createCampaign/stepChange',
      payload: { isBack: isBack, step: 1, isValid: isValid, isStamp: true },
    });
  };


  return (
    <>
      <BaseCreationStepContentByConfig
        configuration={CREATION_STEP_TWO_CONFIG}
        hidePreview={true}
      />
      <ContinueWithBackButtons
        continueAction={() => {
          stepChangeAction(false);
        }}
        backAction={() => {
          stepChangeAction(true);
        }}
      />
    </>
  );
}

const mapPropsToState = (state) => ({});

export default connect(mapPropsToState)(CreateStampCampaignStepTwoV2);
